<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        11.07
        <br />2017
      </span>
      <span class="tiel">美菜网受邀参加首届“双新双创”博览会</span>
    </div>
    <div class="mat-content">
      <div
        class="tet-js"
      >导语：2017年11月6日，美菜网接到农业部农村创业创新推进组的邀请，将于11月9日-12日参加首届全国“互联网+”现代农业新技术和新农民创业创新博览会（简称“双新双创”博览会）</div>
    </div>

    <div class="mat-content">
      <div
        class="tet-js"
      >据悉，这是继去年全国“互联网+”现代农业工作会议后，美菜网参加的又一农业盛会。届时，创始人刘传军将在大会上作出《美菜大源头战略 开创农业服务新模式》的主题演讲。作为互联网+农业创新创业及B2B农产品电商的主要代表，美菜网还会在博览会上向大家展示三年来技术成果和发展路径。</div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a6_01.jpg" width="640" />
      </p>
    </div>
    <div class="mat-content">
      <div
        class="tet-js"
      >此次双新双创”博览会由农业部、江苏省人民政府主办，江苏省农业委员会、苏州市人民政府承办。将集中推出一批“互联网+”现代农业新技术、新模式、新业态，展示一批新农民创业创新典型和社会主义新农村建设样板，打造农业信息化全产业、全链条、全过程的交流、洽谈、合作平台。</div>
    </div>
    <div class="mat-content">
      <div
        class="tet-js"
      >美菜网致力于通过互联网的方式来改变农业、农村和农民，打通农产品流通环节，推动农业产业化发展。其独有的“新农业模式”通过自建仓储、物流、配送，创新升级农产品供应链，砍掉所有的中间环节，实现农户和餐厅的直接交付。同时，美菜利用大数据系统，准确将市场需求反馈给农民，一方面避免了货不对市，另一方面通过解决销路给予了农民安心的保障。此外，美菜利用自身的渠道优势，要求源头端建立生产标准，保证上行农产品的质量安全，真正实现生产有标准、销路有保障的良性循环。</div>
    </div>
    <div class="mat-content">
      <div
        class="tet-js"
      >在过去的三年多时间里，美菜网全面布局，覆盖全国近50个城市，估值已超过30亿美金，已经成为国内知名的农产品移动电商平台。截止2017年9月，美菜日包裹处理量超过100万个，配送次数已超3000万次，累计已服务过的商户超过100万家。预计到2017年底，美菜网农产品上行将超过百亿元规模，其中，果蔬产品将超过8亿斤。</div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a6_02.jpg" width="640" />
      </p>
    </div>
    <div class="mat-content">
      <div
        class="tet-js"
      >美菜将会在此次博览会上发布大源头战略，以现有中央仓为支点，将以探索成功的标准化模式覆盖三、四、五线城市，供应链进一步下沉到农村市场，推动农村农业的发展，落实供给侧结构性改革。</div>
    </div>
    <div class="mat-content">
      <div
        class="tet-js"
      >业内人士认为，“互联网+”热潮兴起，农业农村互联网化已势不可挡，相信美菜网在首届双新双创”博览会之后，会实现农产品上行超千亿规模，真正助力农产品上行，为农业农村市场注入新动力。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
